import { Component, OnInit } from '@angular/core';
import { BaseCrudComponent } from '@app/admin/base-crud.component';
import { AlertService, DatasourceService, AuthService } from '@app/core/services';
import { State } from '@progress/kendo-data-query';
import { environment } from '@environments/environment';
import { BreadCrumbItem } from "@progress/kendo-angular-navigation";


@Component({
  selector: 'versions-crud',
  templateUrl: './versions-crud.component.html',
  providers: [ DatasourceService ]
})
export class VersionsCrudComponent extends BaseCrudComponent implements OnInit {

  protected label: string = 'Versión';

  protected name: string = 'Versiones';

  protected table: string = 'versions';

  protected version_app: string = environment.version;

  protected version_bd: string = environment.version;
  
  constructor(protected authService: AuthService, protected service : DatasourceService, protected alertService : AlertService) {
    
    super(authService, service, alertService);
    console.log(this.constructor.name);
    this.breadcrumbItems = this.getBreadcumItems();

  }  
  
  protected getBreadcumItems(): BreadCrumbItem[] {
    return [
      {
        icon: "home",
        disabled: true
      },      
      {
        text: this.name,
        icon: 'parameter-float'
      }
    ];
  }

  protected getInitialState() : State {

    let s = this.service.getStateEmpty();
    s.sort = [     
      {field: 'created', dir: 'desc'}
    ];

    return s;

  }

  protected onUpdate() {

    let url: string = `${environment.apiUrl}/update_v${this.version_app.split(".").join("_")}`;

    window.open(url, "_blank");

    this.version_bd = this.version_app;

    setTimeout (() => {
      this.service.pagination(this.table, this.state);
    }, 5000);

  }

  ngOnInit() { 
    
    super.ngOnInit(); 
    
    this.service.getByColumn(this.table, 'name', this.version_app).subscribe((res: any) => {
         
      if(!res.data.length) {
        this.version_bd = 'UPDATE';
      }

    });

  }

}